import { render, staticRenderFns } from "./empty-list-illustration.vue?vue&type=template&id=5d5cab5e&"
import script from "./empty-list-illustration.vue?vue&type=script&lang=js&"
export * from "./empty-list-illustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports